import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import { useAuth } from '../lib/AuthProvider';
import { useScreen } from '../lib/useScreen';

const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";
const C = { turquesa:'#5dc1b9', mango:'#FDBE02', moradoClaro:'#AFA9EC' };

export default function EspacioOtroPage() {
  const { userId } = useParams();
  const { membership } = useAuth();
  const { isMobile } = useScreen();
  const navigate = useNavigate();
  const [emprendedor, setEmprendedor] = useState(null);
  const [pensamientos, setPensamientos] = useState([]);
  const [activo, setActivo] = useState(null);

  const isFree = !membership || membership === 'free_observer' || membership === 'tu_radar';

  useEffect(() => {
    supabase.from('profiles').select('id, full_name, business_name, business_type, business_stage, avatar_url, city')
      .eq('id', userId).single().then(({ data }) => setEmprendedor(data));
    supabase.from('pensamientos').select('*').eq('user_id', userId).eq('visibilidad', 'publico')
      .order('created_at', { ascending: false }).then(({ data }) => { setPensamientos(data || []); if (data?.length) setActivo(data[0]); });
  }, [userId]);

  const nombre = emprendedor?.full_name || emprendedor?.business_name || 'Emprendedor';

  return (
    <div style={{ background:'#0a0a0a', minHeight:'100vh', fontFamily:font, color:'#fff' }}>
      {/* Header */}
      <header style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'11px 16px', borderBottom:'0.5px solid rgba(255,255,255,0.06)' }}>
        <button onClick={() => navigate('/sala')} style={{ background:'rgba(83,74,183,0.25)', border:'0.5px solid rgba(175,169,236,0.5)', color:C.moradoClaro, padding:'5px 12px', borderRadius:7, fontSize:12, cursor:'pointer', display:'flex', alignItems:'center', gap:6, fontWeight:500, fontFamily:'inherit' }}>
          ← Regresar a La Sala
        </button>
        <span style={{ fontSize:12, color:'rgba(255,255,255,0.5)' }}>👁️ Viendo a {nombre.split(' ')[0]}</span>
      </header>

      <div style={{ display:'flex', flexDirection:isMobile?'column':'row', minHeight:'calc(100vh - 50px)' }}>
        {/* Sidebar */}
        <aside style={{ width:isMobile?'100%':230, borderRight:isMobile?'none':'0.5px solid rgba(255,255,255,0.06)', borderBottom:isMobile?'0.5px solid rgba(255,255,255,0.06)':'none', padding:'14px 10px', background:'rgba(255,255,255,0.012)', display:'flex', flexDirection:'column', overflowY:'auto', maxHeight:isMobile?'40vh':'none' }}>
          {/* Author card */}
          <div style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 8px', marginBottom:14 }}>
            <div style={{ width:36, height:36, borderRadius:'50%', background:'linear-gradient(135deg, #5dc1b9, #FDBE02)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:14, fontWeight:600 }}>
              {nombre[0]}
            </div>
            <div>
              <p style={{ margin:0, fontSize:13, fontWeight:500 }}>{nombre}</p>
              <p style={{ margin:0, fontSize:10, color:'rgba(255,255,255,0.5)' }}>{emprendedor?.business_type || ''} · {emprendedor?.business_stage || ''}{emprendedor?.city ? ` · ${emprendedor.city}` : ''}</p>
            </div>
          </div>

          <p style={{ margin:'0 8px 10px', fontSize:10, color:'rgba(255,255,255,0.5)', letterSpacing:1, textTransform:'uppercase' }}>Sus pensamientos · {pensamientos.length}</p>

          <div style={{ display:'flex', flexDirection:'column', gap:2, flex:1 }}>
            {pensamientos.map(p => (
              <button key={p.id} onClick={() => setActivo(p)} style={{
                padding:'9px 11px', background: activo?.id === p.id ? 'rgba(93,193,185,0.12)' : 'transparent',
                border:0, borderLeft: activo?.id === p.id ? `2px solid ${C.turquesa}` : '2px solid transparent',
                borderRadius: activo?.id === p.id ? '0 6px 6px 0' : 6,
                textAlign:'left', cursor:'pointer', width:'100%', fontFamily:'inherit', color:'#fff',
              }}>
                <p style={{ margin:0, fontSize:12, fontWeight: activo?.id === p.id ? 500 : 400, color: activo?.id === p.id ? C.turquesa : 'rgba(255,255,255,0.75)' }}>{p.titulo}</p>
                <p style={{ margin:'2px 0 0', fontSize:10, color:'rgba(255,255,255,0.35)' }}>{new Date(p.created_at).toLocaleDateString('es')}</p>
              </button>
            ))}
            {pensamientos.length === 0 && (
              <p style={{ padding:'20px 10px', fontSize:12, color:'rgba(255,255,255,0.4)', textAlign:'center' }}>Este emprendedor aún no ha publicado pensamientos.</p>
            )}
          </div>

          {/* Connect card */}
          <div style={{ margin:'14px 4px 0', padding:12, background:'rgba(255,255,255,0.03)', border:'0.5px solid rgba(255,255,255,0.08)', borderRadius:10 }}>
            <p style={{ margin:'0 0 4px', fontSize:10, color:isFree ? C.mango : C.turquesa, fontWeight:500 }}>
              {isFree ? '🔒 Conecta con ' : '💬 Conecta con '}{nombre.split(' ')[0]}
            </p>
            <p style={{ margin:'0 0 8px', fontSize:11, color:'rgba(255,255,255,0.6)', lineHeight:1.5 }}>
              {isFree ? 'En Free podés leer sus pensamientos. Para mandar mensaje necesitás Spark.' : 'Mandale un mensaje directo.'}
            </p>
            {isFree ? (
              <button onClick={() => navigate('/membresias')} style={{ width:'100%', padding:6, background:'linear-gradient(135deg, #534AB7, #1D9E75)', border:0, color:'#fff', borderRadius:7, fontSize:10, fontWeight:500, cursor:'pointer', fontFamily:'inherit' }}>
                Spark · $139/mes →
              </button>
            ) : (
              <button style={{ width:'100%', padding:6, background:C.turquesa, border:0, color:'#fff', borderRadius:7, fontSize:10, fontWeight:500, cursor:'pointer', fontFamily:'inherit' }}>
                💬 Mandar mensaje
              </button>
            )}
          </div>
        </aside>

        {/* Main content */}
        <main style={{ flex:1, padding:isMobile?'16px 12px':'20px 28px', overflowY:'auto' }}>
            {activo ? (
              <article>
                <div style={{ display:'inline-block', padding:'3px 10px', background:'rgba(93,193,185,0.1)', border:'0.5px solid rgba(93,193,185,0.2)', borderRadius:50, fontSize:10, color:C.turquesa, marginBottom:12 }}>
                  👁️ Solo lectura
                </div>
                {activo.tags?.length > 0 && (
                  <div style={{ display:'flex', gap:6, marginBottom:8 }}>
                    {activo.tags.map((t, i) => <span key={i} style={{ padding:'3px 9px', background:'rgba(93,193,185,0.12)', color:C.turquesa, borderRadius:999, fontSize:11 }}>{t}</span>)}
                  </div>
                )}
                <h1 style={{ fontFamily:serif, fontSize:24, fontWeight:400, margin:'0 0 6px' }}>{activo.titulo}</h1>
                <p style={{ margin:'0 0 16px', fontSize:11, color:'rgba(255,255,255,0.4)' }}>{new Date(activo.created_at).toLocaleDateString('es')}</p>
                <div style={{ fontSize:15, color:'rgba(255,255,255,0.85)', lineHeight:1.8 }} dangerouslySetInnerHTML={{ __html: activo.contenido }} />
              </article>
            ) : (
              <div style={{ textAlign:'center', padding:'4rem 0' }}>
                <p style={{ fontSize:14, color:'rgba(255,255,255,0.4)' }}>Selecciona un pensamiento de la lista.</p>
              </div>
            )}
          </main>
      </div>

      <style>{`.wikilink { color:#5dc1b9 !important; background:rgba(93,193,185,0.12); padding:1px 5px; border-radius:4px; text-decoration:underline dotted; font-weight:500; }`}</style>
    </div>
  );
}
